import { combineReducers, configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import notificationSlice from "./slices/notificationSlice";
import sellerSlice from "./slices/sellerSlice";
import watcherSaga from "./sagas";
import sellerDataSlice from "./slices/sellerDataSlice";
import userListSlice from "./slices/sellerDataUserListSlice";
import userDataSlice from "./slices/userDataSlice";
import sellerNotificationSlice from "./slices/sellerNotificationSlice";
import subSellerSlice from "./slices/subSellerSlice";
import userSlice from "./slices/userSlice";
import paymentSlice from "./slices/paymentSlice";

const reducer = combineReducers({
  seller: sellerSlice,
  subSeller: subSellerSlice,
  notification: notificationSlice,
  sellerData: sellerDataSlice,
  userData: userDataSlice,
  sellerDataUserList: userListSlice,
  sellerNotification: sellerNotificationSlice,
  userManagement: userSlice,
  paymentCatalogue: paymentSlice,
});

const sagaMiddleware = createSagaMiddleware();

const middleware = (getDefaultMiddleware) => [
  ...getDefaultMiddleware({ thunk: false, serializableCheck: false }),
  sagaMiddleware,
];

const store = configureStore({
  reducer,
  middleware,
});

sagaMiddleware.run(watcherSaga);

export default store;
